<template>
  <!-- 钉钉风格 选择登录用户/机构 -->
  <el-dialog
    title="选择登录身份"
    :visible.sync="visible"
    width="460px"
    @close="close"
    class="select-user-dialog"
  >
    <div class="user-account-info">
      <i class="el-icon-user"></i>
    </div>
    <div class="user-list-wrapper">
      <div
        class="user-item"
        v-for="item in AuthUserList"
        :key="item.id"
        @click="selectUser(item)"
        :class="{ active: userId === item.id }"
      >
        <div class="info">
          <div class="">{{ item.name }}</div>
          <div class="org">{{ item.orgName || '学校用户' }}</div>
        </div>
        <i class="el-icon-check" v-if="userId === item.id"></i>
      </div>

      <!-- 空数据 -->
      <div class="empty" v-if="AuthUserList.length === 0">
        暂无可登录的用户
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button
        type="primary"
        :disabled="!userId"
        @click="confirmSwitch"
      >
        确认切换
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
	import {
		getUserMenuTree,
		schoolSemeter
	} from '../login.js'
export default {
  name: 'changeUser',
  props: {
    show: { type: Boolean, default: false },
    // 从父组件传入：该账号下的用户列表（接口获取）
    AuthUserList: { type: Array, default: () => [] },
  },
  data() {
    return {
      userId: null, // 选中的用户ID
	  id:localStorage.getItem('userId'),
	  login:null,
    }
  },
  computed: {
    visible: {
      get() { return this.show },
      set(val) { this.$emit('update:show', val) }
    }
  },
  methods: {
	  loginOpen(text) {
	    this.login = this.$loading({
	      lock: true,
	      text: text,
	      zIndex: 100001,
	      spinner: 'el-icon-loading',
	      background: 'rgba(0, 0, 0, 0.7)'
	    });
	  },
	  noLogin(){
	    if(this.login){
	      this.login.close()
	      this.login = null;
	    }
	  },
    close() {
      this.activeId = null
      this.$emit('update:show', false)
    },
    // 点击选择用户
    selectUser(user) {
      this.userId = user.id
    },
    // 确认切换 → 抛给父组件调用接口
   async confirmSwitch() {
     this.loginOpen('切换登陆用户中...')
     try {
       // 1. 必须加 await！！！
       let res = await this.API.post(this.API.fileurl.postAuthSwitchUser, {
         userId: this.userId,
         token: localStorage.getItem('token'),
         userType: localStorage.getItem('userType')
       })
   
       // 2. 拿到返回值存信息
       let token = res.data.data.token
       let userInfo = res.data.data.userInfo
   
       localStorage.setItem('token', token)
       let list = ['', 'AI智能体互动课堂管理中台', 'AI智能体互动课堂校平台', 'AI智能体互动课堂学生端', '科学实验家长平台', 'AI智能体互动课堂家长端', 'AI智能体互动课堂局端平台']
       let orgLogo = userInfo.orgLogo ? userInfo.orgLogo : list[userInfo.userType]
   
       localStorage.setItem('nickName', userInfo.nickName || '')
       localStorage.setItem('roleType', userInfo.roleType.toString() || '')
       localStorage.setItem('roleName', userInfo.roleName || '')
       localStorage.setItem('userId', userInfo.id)
       localStorage.setItem('userType', userInfo.userType)
       localStorage.setItem('orgStatus', userInfo.orgStatus)
       localStorage.setItem('orgName', userInfo.orgName)
       localStorage.setItem('orgLogo', orgLogo)
       localStorage.setItem('orgId', userInfo.orgId)
   
       // 3. 菜单接口也要 await
       await getUserMenuTree()
	   await schoolSemeter()
       // 4. 有 authId 就存
       if (res.data.data.authId) {
         localStorage.setItem('authId', res.data.data.authId)
       }
   
       // 5. 成功收尾
       this.noLogin()
       this.close()
       this.$emit('success')
   
     } catch (err) {
       console.error('切换用户失败：', err)
       this.noLogin()
     }
   }
  }
}
</script>

<style scoped>
.user-account-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #666;
  padding: 0 10px 12px;
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 12px;
}

.user-list-wrapper {
  max-height: 380px;
  overflow-y: auto;
}

/* 钉钉风格用户卡片 */
.user-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 8px;
  transition: all 0.2s;
}
.user-item:hover {
  background-color: #f7f8fa;
}
.user-item.active {
  background-color: #e8f3ff;
  border: 1px solid #409eff;
}

/* 头像 */
.avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  margin-right: 12px;
}

/* 信息 */
.info {
  flex: 1;
}
.name {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}
.org {
  font-size: 13px;
  color: #999;
}

/* 选中图标 */
.el-icon-check {
  color: #409eff;
  font-size: 18px;
}

.empty {
  text-align: center;
  padding: 40px 0;
  color: #999;
}

.dialog-footer {
  text-align: right;
}
</style>